import Vue from 'vue'
import Utils from './Utils'
import Auth from './Auth'
export default {
  url: Auth.getUrl('user'),
  paginate (meta) {
    return Utils.paginate(this.url, meta)
  },
  get (id) {
    return Vue.http.get(this.url + '/' + id)
  },
  create (data) {
    return Vue.http.post(this.url, data)
  },
  update (data) {
    return Vue.http.put(this.url + '/' + data.id, data)
  },
  remove (id) {
    return Vue.http.delete(this.url + '/' + id)
  },
  getBaseItem () {
    return {
      id: null,
      email: '',
      first_name: '',
      last_name: '',
      status: 1,
      password: '',
      password2: ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/Users.js